import { iso2ToIso3 } from "@/utils/iso3166Alpha2ToAlpha3";

export function getRestrictCountryIso3Codes(shippingCountries = []) {
  if (!shippingCountries.length) {
    return [];
  }

  return [
    ...new Set(
      shippingCountries.map(country => iso2ToIso3(country.isoCode)).filter(Boolean)
    )
  ];
}

export function getAddressFinderRestrictCountries({
  shippingCountries = [],
  countryIso2,
  lockCountry = false
} = {}) {
  if (lockCountry && countryIso2) {
    return [getDefaultCountryIso3(countryIso2)];
  }

  return getRestrictCountryIso3Codes(shippingCountries);
}

export function getDefaultCountryIso3(countryIso2) {
  return iso2ToIso3(countryIso2) || "GBR";
}

function normaliseCountryToken(value) {
  return String(value || "")
    .trim()
    .toUpperCase();
}

function findShippingCountry(shippingCountries, address, fallbackIso2) {
  const candidates = [
    address?.country_iso,
    address?.country_iso_2,
    address?.country,
    fallbackIso2
  ]
    .map(normaliseCountryToken)
    .filter(Boolean);

  for (const candidate of candidates) {
    const byIso = shippingCountries.find(
      country => normaliseCountryToken(country.isoCode) === candidate
    );
    if (byIso) {
      return byIso;
    }

    const byIso3 = shippingCountries.find(
      country => iso2ToIso3(country.isoCode) === candidate
    );
    if (byIso3) {
      return byIso3;
    }

    const byName = shippingCountries.find(
      country => normaliseCountryToken(country.name) === candidate
    );
    if (byName) {
      return byName;
    }
  }

  return null;
}

export function resolveCountryFormValue({
  shippingCountries = [],
  address,
  fallbackIso2,
  countryValueType = "isoCode"
}) {
  const shippingCountry = findShippingCountry(shippingCountries, address, fallbackIso2);
  if (!shippingCountry) {
    return undefined;
  }

  if (countryValueType === "id") {
    return shippingCountry.id;
  }

  return shippingCountry.isoCode;
}
